// JsFromRoutes CacheKey e05d9a10611af20f2367bab9bc7d8c5f
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@consumer/services/api'

export default {
  sendTestEmail: /* #__PURE__ */ definePathHelper('post', '/testing_tools/contacts/update_prompt/send_test_email'),
}
